import React from 'react';

interface SvgProps extends React.SVGProps<SVGSVGElement> {
  size: 'large';
  backgroundSecondary: string;
  backgroundTertiary: string;
  textBody: string;
}

const NoMatchingIcon: React.FC<SvgProps> = ({ size, backgroundSecondary, backgroundTertiary, textBody, ...props }) => (
  <>
    {size === 'large' &&
      <svg width="84" height="84" viewBox="0 0 84 84" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="7" y="7" width="70" height="70" rx="35" fill={backgroundTertiary} />
        <rect x="7" y="7" width="70" height="70" rx="35" stroke={backgroundSecondary} strokeWidth="12.5" />
        <path d="M42 36.1666V42M42 47.8333H42.0145M56.5833 42C56.5833 50.0541 50.0541 56.5833 42 56.5833C33.9458 56.5833 27.4166 50.0541 27.4166 42C27.4166 33.9458 33.9458 27.4166 42 27.4166C50.0541 27.4166 56.5833 33.9458 56.5833 42Z" stroke={textBody} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    }
  </>
);

export default NoMatchingIcon;